export default __webpack_public_path__ + "data/artworks-count-year-techniques.csv";